<template>
  <div class="account-safty">
    <h1 class="title">账号安全</h1>
    <div class="safty-check">
      <p style="font-size:16px;color:#333333;display:inline;float:left;margin:0;">您的账号安全级别</p>
      <div class="safty" style="position:relative;display:inline;float:left;">
        <img
          src="../../../../assets/safty-pointer.png"
          style="position:absolute;top:-12px;"
          class="position-lower"
          v-if="saftyLevel===0"
        >
        <img
          src="../../../../assets/safty-pointer.png"
          style="position:absolute;top:-12px;"
          class="position-middle"
          v-if="saftyLevel===1"
        >
        <div class="safty-warning"></div>
        <p style="font-size:10px;color:#b5b5b5;margin:0;margin-left:6px;">
          <span style="letter-spacing:320px;margin-top:5px;display:inline-block;">||</span>
          <span style="margin-top:5px;display:inline-block;">|</span>
        </p>
        <p style="font-size:14px;color:#333333;margin:0;">
          <span style="letter-spacing:307px;margin-top:5px;display:inline-block;">低中</span>
          <span style="margin-top:5px;display:inline-block;">高</span>
        </p>
      </div>
      <div style="clear:both;"></div>
      <p style="font-size:14px;margin:50px 0 20px 0px;color:#666666;text-align:center">
        您的账号安全级别
        <span style="color:#d42020" v-if="saftyLevel===0">“较低”</span>
        <span style="color:#6be164" v-if="saftyLevel===1">“中”</span>
        <!-- 建议启动全部安全设置，以保障账号安全！ -->
      </p>
      <!-- <p style="font-size:16px;color:#333333;margin-bottom:48px;">建议您进行以下安全设置</p>
      <p class="safty-change" style="margin-bottom:55px;">
        <span class="safty-span">登录密码</span> 安全性高的密码可以使帐号更安全，建议您定期更换密码。
        <el-button
          type="primary"
          @click="$router.push('/trainClass/personalCenter/accountInfo/throughWay/pass')"
        >修改</el-button>
      </p>
      <p class="safty-change" style="margin-bottom:55px;">
        <span class="safty-span">手机验证</span>您已绑定了手机 {{phone}} [您的手机为安全手机，可以找回密码，但不能用于登录]
        <el-button
          type="primary"
          @click="$router.push('/trainClass/personalCenter/accountInfo/throughWay/phone')"
        >修改</el-button>
      </p>
      <p class="safty-change" style="margin-bottom:55px;">
        <span class="safty-span">邮箱</span>您已绑定了邮箱 {{email.length > 25 ? email.substring(0,25)+'...' : email}} [您的邮箱为安全邮箱，可以找回密码，但不能用于登录]
        <el-button
          type="primary"
          @click="$router.push('/trainClass/personalCenter/accountInfo/throughWay/email')"
        >修改</el-button>
      </p>
      <p class="safty-change">
        <span class="safty-span">密保问题</span>建议您设置一个容易记住，且最不容易被他人获取的问题及答案，更有效保障您的密码安全。
        <el-button
          type="primary"
          @click="$router.push('/trainClass/personalCenter/accountInfo/throughWay/question')"
        >修改</el-button>
      </p> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      saftyLevel: 1,
      email: '',
      phone: ''
    };
  },
  created() {
    if (sessionStorage.token === "" || sessionStorage.token === undefined) {
      this.$message.info("请先登录");
      this.$router.push("/login");
    }
    // this.$ajax
    //   .post(
    //     "/comuser-service/Account/securityLevel",
    //     this.postData({
    //       id: sessionStorage.userUuid.toString()
    //     })
    //   )
    //   .then(res => {
    //     this.saftyLevel = res.data;
    //   });
    // this.$ajax
    //   .post(
    //     "/comuser-service/Account/seeAccount",
    //     this.postData({
    //       id: sessionStorage.userUuid
    //     })
    //   )
    //   .then(res => {
    //     this.phone = res.data.tbAccount.mobile.substr(0, 3) + '****' + res.data.tbAccount.mobile.substr(7);
    //     this.email = res.data.tbAccount.emailAddress
    //   });
  }
};
</script>
<style lang="scss">
.account-safty {
  width: 1020px;
  background: rgb(255, 255, 255);
  margin-left: 35px;
  .title {
    font-weight: normal;
    font-size: 16px;
    margin: 15px 0 25px;
    color: #333333;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
    padding: 0 00px 10px;
    margin-left: 10px;
  }
  .safty-check {
    margin: 60px 0 30px 40px;
    .position-low {
      top: -12px;
    }
    .position-lower {
      left: 110px;
    }
    .position-middle {
      left: 321px;
    }
    .safty {
      margin-top: 6px;
      margin-left: 30px;
      .safty-warning {
        width: 650px;
        height: 10px;
        background: linear-gradient(to right, #ed2e2d, #6be164, #0273eb);
        border-radius: 10px;
        margin-left: 8px;
      }
    }
    .safty-change {
      font-size: 14px;
      color: #666666;
      margin: 0;
      border-bottom: 1px #eeeeee solid;
      padding-bottom: 10px;
      margin-right: 30px;
      .safty-span {
        display: inline-block;
        width: 100px;
        font-size: 16px;
        color: #1060ab;
      }
      .el-button {
        float: right;
        height: 25px;
        padding: 5px 15px;
        font-size: 14px;
        background-color: #1060ab;
        border-color: #1060ab;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/accountSafty.vue